<script lang="ts">
  import { getAppConfig } from '../../../common/config/app-config';
  import { getStr, isDirectionRTL } from '../../../common/util';
  import Text from '../../common/components/Text.svelte';

  export let data;
  const { themeResourcePath } = getAppConfig();
  const isRTL = isDirectionRTL();

  const shopDetails = data?.marketPlaceShopDetails;
  const isMarketplaceProduct = !!data?.marketPlaceProduct && shopDetails !== null;
  const shopName = shopDetails?.name ?? getStr('extra.marketplace.seller.extra');
  const sellerExtra = getStr('extra.marketplace.seller.extra');
  const sellerMarketplace = `<span class="mp-seller-name">${shopDetails?.name}</span>`;
</script>

<div class="seller-info" class:mp-seller-info={isMarketplaceProduct} class:rtl={isRTL}>
  {#if !isMarketplaceProduct}
    <span class="extraSpecial-icon">
      <img class="icon-seller extra" src={`${themeResourcePath}/images/seller-icon-extra.svg`} alt="" />
    </span>
  {:else}
    <img class="icon-seller" src={`${themeResourcePath}/images/seller-icon-other.svg`} alt="" />
  {/if}

  <div class={!isMarketplaceProduct ? 'seller-text-container' : 'mp-seller-text-container'}>
    <p class="seller-text">
      {#if (data?.marketPlaceOfferData?.shippedBySeller && isMarketplaceProduct) || !isMarketplaceProduct}
        <Text key="extra.marketplace.seller.soldandshipped" args={[shopName]} />
      {:else}
        <Text key="extra.marketplace.soldbyseller.shippedbyextra.label" args={[sellerMarketplace, sellerExtra]} />
      {/if}
    </p>
  </div>
</div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .seller-info {
    display: flex;
    align-items: center;
    padding-top: 10px;
    padding-bottom: 8px;
    margin-top: 6px;
    @include responsive {
      padding: 17px 0 0 16px;
      margin-left: 0;
    }

    &.rtl {
      .seller-text-container {
        border-top-left-radius: 0;
        left: -8px;
      }
      .seller-text-container::after {
        top: -1px;
        border: none;
        border-top: 1px solid $primary-blue;
        width: 20px;
        height: 21px;
        background: $neutral-light-04;
        left: -15px;
        border-top-left-radius: 0;
        @include responsive {
          background-color: $primary-white;
        }
      }
    }
    .icon-seller {
      z-index: 2;
      position: relative;
      &.extra {
        filter: brightness(0) saturate(100%) invert(27%) sepia(97%) saturate(668%) hue-rotate(172deg) brightness(91%)
          contrast(91%);
      }
    }
    .seller-text-container {
      border-radius: 8px;
      border: 1px solid $primary-blue;
      border-left: none;
      background-color: $neutral-light-04;
      padding: 3px 9px 3px 24px;
      position: relative;
      left: -16px;
      width: 100%;
      border-top-left-radius: 19px;
      @include responsive {
        background-color: $primary-white;
      }
    }
    .seller-text-container::after {
      content: '';
      position: absolute;
      bottom: -1px;
      border-bottom: 1px solid $primary-blue;
      left: 0;
      height: 16px;
      width: 24px;
      background: $neutral-light-04;
      left: -6px;
      border-top-left-radius: 18px;
      @include responsive {
        background-color: $primary-white;
      }
    }

    :global {
      .png-icon,
      svg {
        z-index: 2;
        position: relative;
      }
      .mp-seller-name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .mp-seller-text-container .seller-text strong:first-of-type {
        max-width: 55%;
        display: flex;
        @include responsive {
          max-width: 45%;
        }
      }
    }
  }
  .seller-text {
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    color: $neutral-dark-01;
    margin: 0;

    .seller-link {
      font-weight: 500;
      text-decoration: underline;
    }

    .seller-name {
      font-weight: 700;
    }
  }

  .mp-seller-text-container {
    background-color: $neutral-light-04;
    border-radius: 8px;
    border: 1px solid $primary-blue;
    border-left: none;
    padding: 4px 8px 4px 20px;
    position: relative;
    left: -8px;
    width: 93%;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    // top: 4px;
    @include responsive {
      width: 90%;
      background-color: $primary-white;
      padding: 4px 8px 4px 20px;
    }
    .seller-text {
      display: flex;
      gap: 5px;
      color: $black;
    }
  }
</style>
